import {UserState} from "./interface/userInterface"
import {Action} from "./interface/baseInterface"
const userState = {
    info: {id: ""},
    permissions: {unable: false, times: 600, used: 100},
}

export const userReducer = (state: UserState = userState, action: Action) => {
    const payload = action.payload

    switch (action.type) {
        case "TDAInit": {
            return {
                ...userState,
            }
        }
        case "updateUser": {
            return {
                ...state,
                ...payload,
            }
        }
        default:
            return {...state}
    }
}
